export default __webpack_public_path__ + "static/media/avatar_1_2.855005fb.png";